import React, { memo } from 'react';

import { IconProps } from './iconInterfaces';

export const AqiChildrenHealthAdviceIcon = memo(({ width=17, height=20, symbolFillColor='#8E8E93' }: IconProps) => {
    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M3.5 0C4.6 0 5.5 0.9 5.5 2C5.5 3.1 4.6 4 3.5 4C2.4 4 1.5 3.1 1.5 2C1.5 0.9 2.4 0 3.5 0ZM12.5 7.5C12.5 8.33 13.17 9 14 9C14.83 9 15.5 8.33 15.5 7.5C15.5 6.67 14.83 6 14 6C13.17 6 12.5 6.67 12.5 7.5ZM15.5 10H12.66C12.08 10.01 11.52 10.32 11.21 10.86L10.29 12.18L6.72 6C6.35 5.37 5.69 5.01 5.01 5H2C0.9 5 0 5.9 0 7V12C0 12.55 0.45 13 1 13H1.5V19C1.5 19.55 1.95 20 2.5 20H5.5C6.05 20 6.5 19.55 6.5 19V9.61L8.74 13.5C8.92 13.81 9.25 14 9.61 14H10.71C11.04 14 11.34 13.84 11.53 13.57L12 12.9V19C12 19.55 12.45 20 13 20H15C15.55 20 16 19.55 16 19V15C16.55 15 17 14.55 17 14V11.5C17 10.68 16.33 10 15.5 10Z' fill={symbolFillColor} />
        </svg>
    );
});

AqiChildrenHealthAdviceIcon.displayName = 'AqiChildrenHealthAdviceIcon';
